import { useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Process from "../images/7.png"
import BookYourCall from "../images/1.png"
import BookYourCallRed from "../images/8.png"
import shipBack from "../images/4.png"
import yachtBack from "../images/2.png"
import Testimonials from '../components/Testimonials';
import papers from "../images/papers.png";
import graphicImageUrl from "../images/3.png";
import graphicImageUrl2 from "../images/22.png";
import energyHealImage from "../images/20.png";
import energyHealImage1 from "../images/20_01.png";
import energyHealImage2 from "../images/24.png"; 
import { FaArrowRight } from 'react-icons/fa';
import BellComponent from '../components/BellComponent';
import EmailComponent from '../components/EmailComponent';
function Services() {
    const [message, setMessage] = useState("");
    const handleSubmit = (e) => {
        e.preventDefault();
        alert("Submitted message: " + message);
        setMessage("");
    };
    return (
        <div className="mb-[120px] md:mb-0">
            <Header color="blue" pageName="Vip Services" />
            <div
                className="md:min-h-screen flex flex-col bg-[#edebe6] text-white"
            >
                {/* Main Content */}
                <main className="flex flex-col items-center justify-center flex-grow text-left px-12 pt-28">
                    <h1 className="eb-garamond text-[#f15d16] text-center font-semibold text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl uppercase md:pt-6">
                        TRANSFORMATIONAL  <br />
                        COACHING
                    </h1>
                    <p className='poppins text-xl md:text-3xl w-full md:w-2/3 mx-auto text-center text-black my-4 md:my-8 font-light'> High performers don’t fall apart.<br />
                        They outgrow that old self and build a new one.
                    </p>
                    <p className='poppins text-lg md:text-2xl w-full  md:w-1/2 mx-auto text-center text-black mb-4 md:mb-8 font-extralight'>
                        Your old identity got you here.<br />
                        Relentless, impressive, unstoppable.<br />
                        But now? It’s the thing holding<br /> you back.
                    </p>
                    <p className='poppins text-lg md:text-2xl w-full  md:w-1/2 mx-auto text-center text-black mb-8 font-extralight'>

                        Burnout isn’t a flaw.<br />
                        It’s what happens when  <br />your life evolves,<br />
                        but your inner programming doesn’t.
                    </p>

                </main>
                <div
                    className="w-full h-[150px] md:h-[250px] bg-size-[unset] md:bg-cover"
                    style={{
                        backgroundImage: `url(${shipBack})`,
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                    }}
                ></div>
            </div>
            <div className="bg-[#edebe6] text-white py-6 md:py-12 px-8 " >
                <div className='container mx-auto'>
                    <img
                        src={Process}
                        alt="Logo"
                        className="mb-8 w-full  md:w-1/2 h-full object-contain mx-auto"
                    />
                    <p className='poppins text-lg md:text-2xl w-full md:w-1/2 mx-auto text-center text-black mb-4 md:mb-12 font-extralight'>
                        High achievers don’t burn out because<br />
                        something is wrong with them;
                    </p>
                    <p className='poppins text-lg md:text-2xl w-full  md:w-1/2 mx-auto text-center text-black mb-12 font-extralight'>

                        They burn out because their life<br />
                        upgraded, and their internal operating <br className='hidden md:block' />
                        system didn’t.
                    </p>
                </div>
            </div>
            <div className="min-h-screen  grid-cols-2 background-with-image-blue hidden items-stretch md:grid">
                <div className="w-3/2 p-8 py-16 px-12 md:px-0 md:pl-16 text-white ">
                    <section className="pb-5">
                        <h2 className="eb-garamond text-4xl font-semibold tracking-wider mb-6 text-center md:text-left">
                            YOU'RE IN THE RIGHT ROOM, IF:
                        </h2>
                        <ul className="poppins list-disc md:pl-5 space-y-4 text-lg md:text-xl text-center md:text-left">
                            <li>
                                You fixed your life more than once and still feel a vague, aching gap.
                            </li>
                            <li>
                                You're the stable one for everyone else, and you're tired of being their emergency exit.
                            </li>
                            <li>
                                You're praised for having it together while your chest feels like a clenched fist.
                            </li>
                            <li>
                                You're more afraid of staying numb than you are of changing your life.
                            </li>
                        </ul>
                    </section>
                    <BellComponent isWhite={true} />
                    <section className="py-10">
                        <h2 className="eb-garamond text-4xl font-semibold tracking-wider mb-6 text-center md:text-left">
                            THIS IS NOT FOR YOU IF:
                        </h2>
                        <ul className="poppins list-disc md:pl-5 space-y-4 text-lg md:text-xl text-center md:text-left">
                            <li>
                                You want motivation, not uncomfortable honesty.
                            </li>
                            <li>
                                You'd rather stay in analysis, blame, or group chat advice than reclaim agency.
                            </li>
                            <li>
                                You're collecting coaches or program highs instead of committing to real change.
                            </li>
                            <li>
                                You want someone to save you instead of learning to stop abandoning yourself.
                            </li>
                        </ul>
                    </section>
                </div>

                <div className="w-2/3 ml-auto" style={{
                    backgroundImage: `url(${yachtBack})`,
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                }}>
                </div>

            </div>
            <div className='pb-8  background-with-image-blue md:hidden'>
                <div className="grid-cols-2 items-stretch grid">
                    <div className="w-3/2 pt-8 pl-8 text-white ">
                        <section className="pb-4">
                            <h2 className="eb-garamond text-white text-2xl font-semibold tracking-wider text-left pb-2">
                                YOU'RE IN THE RIGHT ROOM, IF:
                            </h2>
                            <ul className="poppins list-disc md:pl-5 mb-4 space-y-4 text-lg md:text-xl text-left">
                                <li>
                                    You fixed your life more than once and still feel a vague, aching gap.
                                </li>
                                <li>
                                    You're the stable one for everyone else, and you're tired of being their <br />emergency exit.
                                </li>
                                <li>
                                    You're praised for having it together while your chest feels like a <br />clenched fist.
                                </li>

                            </ul>
                        </section>
                    </div>
                    <div className="w-2/3 h-[95%] ml-auto" style={{
                        backgroundImage: `url(${yachtBack})`,
                        backgroundPosition: "center center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                    }}>
                    </div>
                </div>
                <section className="px-4 py-4 text-white text-center">
                    <BellComponent isWhite={true}/>
                    {/* <h2 className="eb-garamond text-2xl text-white font-semibold tracking-wider py-6 text-center">
                        THIS IS NOT FOR YOU IF
                    </h2>
                    <ul className="poppins pl-4 space-y-4 text-lg md:text-xl text-center">
                        <li>
                            You want motivation,<br /> not uncomfortable honesty.
                        </li>
                        <li>
                            You'd rather stay in analysis, blame, or group chat advice then reclaim agency.
                        </li>
                        <li>
                            You're collecting coaches or program highs instead of committing to <br />real change.
                        </li>
                        <li>
                            You want someone to save you instead of learning to stop abandoning yourself.
                        </li>
                    </ul> */}
                </section>
            </div>
            <Testimonials />
            <div className="relative bg-[#edebe6] min-h-screen py-8  hidden md:block" id='energyHealing'>

                {/* --- Background Graphic positioned in the bottom right corner --- */}
                {/* This div is positioned absolutely over the text content to act as a background */}
                <div
                    className="absolute bottom-0 right-0 z-0 h-[80%] w-full pointer-events-none"
                    style={{
                        // Placeholder image URL
                        backgroundImage: `url('${graphicImageUrl}')`,
                        backgroundSize: 'contain', // Ensure the whole graphic is visible
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'bottom right', // Pin it to the bottom right
                    }}
                >
                    {/* Optional overlay/filter if needed */}
                </div>


                {/* --- Header and Text Column (Z-Index 10 to be on top of the graphic) --- */}
                <div className="px-12 md:p-16 relative z-10 text-center md:text-left">

                    {/* --- Section: ENERGY HEALING Title --- */}
                    <h1 className="eb-garamond text-center md:text-left text-5xl lg:text-6xl font-semibold text-[#f15d16] mb-4">
                        ENERGY HEALING
                    </h1>
                    <p className="dreamingOutloudRegular text-center md:text-left text-2xl md:text-4xl italic text-[#80a2a5] mb-8">
                        In collaboration with energy healer Dipti Bley.
                    </p>

                    {/* --- Introduction Paragraphs --- */}
                    <p className="poppins text-lg md:text-xl text-center md:text-left text-gray-600 mb-4 leading-relaxed">
                        Certified Body Code Healer and Certified Co-Active Coach,<br />
                        and I'm passionate about helping people move <br />
                        through what's holding them back whether it's emotional<br />
                        stress, physical discomfort, or simply feeling stuck.
                    </p>
                    <p className="poppins text-lg md:text-xl text-center md:text-left text-gray-600 mb-4 leading-relaxed">
                        Over the years, I've worked with students, professionals, and <br />
                        small business owners, guiding them to create real,<br />
                        lasting shifts in both their personal and professional lives.
                    </p>
                    <p className="poppins text-lg md:text-xl text-center md:text-left text-gray-600 mb-6 leading-relaxed">
                        My approach blends intuitive energy healing with powerful<br />
                        coaching tools so you can release what no longer<br />
                        serves you and step into your full potential.
                    </p>

                    {/* --- Theory Paragraphs --- */}
                    <p className="poppins text-lg md:text-xl text-center md:text-left text-gray-600 mb-4 leading-relaxed">
                        Everything in our body is energy. When we experience stress, trauma, toxic environments, or limiting beliefs,<br />
                        that energy can get "stuck." This often shows up as pain, anxiety, fatigue, or feeling overwhelmed.
                    </p>
                    <p className="poppins text-lg md:text-xl text-center md:text-left text-gray-600 mb-8 leading-relaxed">
                        I use a technique called muscle testing to communicate with your subconscious mind the part of you that<br />
                        remembers everything and knows what your body needs to heal.
                    </p>

                    {/* --- Key Areas Section --- */}
                    <h3 className="poppins text-lg md:text-xl text-center md:text-left font-bold text-gray-800 mb-4 uppercase">
                        We look for imbalances in six key areas:
                    </h3>

                    <ul className="poppins text-lg md:text-xl text-center md:text-left md:list-disc space-y-3 mb-8 pl-0">
                        <li className="text-black">
                            <span className="font-bold mr-1">Energetic</span> (like trapped emotions or unwanted energies)
                        </li>
                        <li className="text-black">
                            <span className="font-bold mr-1">Circuits & Systems</span> (such as organ miscommunication or chakra issues)
                        </li>
                        <li className="text-black">
                            <span className="font-bold mr-1">Toxins</span> (environmental, chemical, or emotional)
                        </li>
                        <li className="text-black">
                            <span className="font-bold mr-1">Pathogens</span> (hidden viruses, bacteria, or parasites)
                        </li>
                        <li className="text-black">
                            <span className="font-bold mr-1">Structural</span> (misalignments in tissues or bones)
                        </li>
                        <li className="text-black">
                            <span className="font-bold mr-1">Nutrition & Lifestyle</span> (imbalances in diet or habits)
                        </li>
                    </ul>

                    {/* --- Conclusion Paragraph --- */}
                    <p className="poppins text-lg md:text-xl text-center md:text-left text-gray-600 mb-10 leading-relaxed">
                        Once we identify what's out of alignment, I use energy and intention <br />
                        and sometimes magnets to help clear the block gently <br />
                        and non-invasively. Many clients tell me they feel <br />
                        lighter, more relaxed, or more focused almost immediately.
                    </p>

                    {/* --- Call to Action Button --- */}
                    <button className="bg-[#80a2a5] rounded-full border-2 border-[#80a2a5] hover:text-[#80a2a5] hover:bg-transparent text-white font-bold py-4 px-10 uppercase tracking-widest text-lg transition duration-300">
                        CONTACT DIPTI
                    </button>
                </div>
            </div>
            <div className="relative bg-[#edebe6] md:min-h-screen py-8 block md:hidden">

                {/* --- Background Graphic positioned in the bottom right corner --- */}
                {/* This div is positioned absolutely over the text content to act as a background */}
                <div
                    className="absolute bottom-0 right-0 z-0 h-[80%] w-full pointer-events-none"
                    style={{
                        // Placeholder image URL
                        backgroundImage: `url('${graphicImageUrl2}')`,
                        backgroundSize: 'contain', // Ensure the whole graphic is visible
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'bottom right', // Pin it to the bottom right
                    }}
                >
                </div>
                <div className="px-8 md:p-16 relative z-10 text-left">

                    {/* --- Section: ENERGY HEALING Title --- */}
                    <h1 className="eb-garamond text-left text-3xl font-semibold text-[#f15d16] mb-4">
                        ENERGY HEALING
                    </h1>
                    <p className="dreamingOutloudRegular text-left text-2xl md:text-4xl italic text-[#80a2a5] mb-8">
                        In collaboration with energy healer Dipti Bley.
                    </p>

                    {/* --- Introduction Paragraphs --- */}
                    <p className="poppins text-md md:text-xl text-left text-gray-600 mb-4 leading-relaxed">
                        Certified Body Code Healer<br /> and Certified Co-Active Coach,<br />
                        and I'm passionate about helping<br /> people move
                        through what's holding them back whether it's emotional<br />
                        stress, physical discomfort, <br />or simply feeling stuck.
                    </p>
                    <p className="poppins text-md md:text-xl text-left text-gray-600 mb-4 leading-relaxed">
                        Over the years, <br />I've worked with students, professionals, and
                        small business owners, guiding them to create real,
                        lasting shifts in both their personal and professional lives.
                    </p>
                    <p className="poppins text-md md:text-xl text-left text-gray-600 mb-6 leading-relaxed">
                        My approach blends intuitive energy healing with powerful
                        coaching tools so you can release what no longer<br />
                        serves you and step into your <br />full potential.
                    </p>
                </div>
            </div>
            <div className="relative bg-[#edebe6] py-4 md:py-8 block md:hidden">
                <div className="px-8 md:p-16 relative z-10 text-center md:text-left"> 
                    <img className='w-full' src={energyHealImage2} ></img>
                    <div>
                        {/* --- Key Areas Section --- */}
                        <h3 className="poppins text-md md:text-xl text-center md:text-left font-bold text-gray-800 pt-4 mb-4 uppercase">
                            We look for imbalances in six key areas:
                        </h3>
                        <ul className="poppins text-md md:text-xl text-center md:text-left mb-8 pl-0 space-y-3">
                            <li className="text-black "><span className='font-bold'>Energetic</span><br />(like trapped emotions or<br /> unwanted energies)
                            </li>
                            <li className="text-black"><span className='font-bold'>Circuits & Systems</span> <br />(such as organ miscommunication or <br />chakra issues)
                            </li>
                            <li className="text-black"><span className='font-bold'>Toxins </span><br />(environmental, chemical, or emotional)
                            </li>
                            <li className="text-black"><span className='font-bold'>Pathogens</span> <br />(hidden viruses, bacteria, or parasites)
                            </li>
                            <li className="text-black"><span className='font-bold'>Structural</span> <br />(misalignments in tissues or bones)
                            </li>
                            <li className="text-black"><span className='font-bold'>Nutrition & Lifestyle</span> <br />(imbalances in diet or habits)
                            </li>
                        </ul>
                        <p className="poppins text-md md:text-xl text-center md:text-left text-gray-600 mb-10 leading-relaxed">
                            Once we identify what's out of alignment, I use energy and intention <br className='hidden md:block' />
                            and sometimes magnets to help clear the<br className='hidden md:block' />
                            block gently and non-invasively. Many clients tell me they feel <br className='hidden md:block' />
                            lighter, more relaxed, or more focused <br className='md:hidden' />almost immediately.
                        </p>
                        <button className="bg-[#80a2a5] rounded-full border-2 border-[#80a2a5] hover:text-[#80a2a5] hover:bg-transparent text-white font-bold py-4 px-10 uppercase tracking-widest text-lg transition duration-300">
                            CONTACT DIPTI
                        </button>
                    </div>
                </div>
            </div>
            <EmailComponent />
            <Footer isblue={true} color="blue" />
        </div >
    );
}
export default Services;